import styled from 'styled-components';

import media from '../../../styles/media.style';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../../styles/variables.style';

export const ListSection = styled.section`
  margin: 50px auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  padding: 0 ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    margin: 120px auto;
  `};
`;

export const EntryContainer = styled.div`
  background-color: #333;
  color: white;
  height: auto;
  margin: auto;
  margin-top: 10px;
  min-height: 340px;
  width: 100%;

  &:first-child {
    margin-top: 0;
  }
`;

export const Entry = styled.div`
  height: 100%;
  padding: 40px 20px;
  width: 100%;

  ${media.tabletL`
    display: flex;
    justify-content: space-between;
    padding: 45px;
  `};
`;

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;

  ${media.tabletL`
    max-width: 225px;
  `};
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-size: 18px;
  width: 100%;

  ${media.tabletL`
    padding-left: 125px;
  `};
`;

export const Title = styled.div`
  font-size: 26px;
  line-height: 1.08;
  letter-spacing: 0.2px;
  margin-bottom: 30px;

  ${media.tabletL`
    font-size: 29px;
    line-height: 1.03;
  `};
`;

export const Type = styled.div`
  color: #ccc;
  font-size: 14px;
  margin-top: 30px;

  ${media.tabletL`
    font-size: 18px;
    margin-top: 0;
  `};
`;

export const Description = styled.div`
  color: #ccc;
  flex-grow: 1;
  font-size: 14px;
  line-height: 1.36;
  margin-top: 20px;

  ${media.tabletL`
    font-size: 18px;
    line-height: 1.28;
  `};
`;

export const Date = styled.div`
  margin-top: 15px;
`;

export const Button = styled.div`
  align-items: center;
  background-color: black;
  color: white;
  cursor: pointer;
  display: flex;
  height: 70px;
  justify-content: center;
  margin: 60px auto 0;
  width: 100%;
`;

export const ButtonLabel = styled.div`
  margin-left: 10px;
`;



// WEBPACK FOOTER //
// ./src/pages/NewsAndEventsPage/ListSection/ListSection.style.js